export enum DeviceFunction {
  PresentAndAcceptAlarms = 'PresentAndAcceptAlarms',
  AbsentAndHandleAlarms = 'AbsentAndHandleAlarms',
  InternalLocation = 'InternalLocation',
  ExternalLocation = 'ExternalLocation',
  VisitorPresent = 'VisitorPresent',
  NoVisitorPresent = 'NoVisitorPresent',
}
